import { Text } from '@distribusion/portal-lib/components';
import { useBreakpoint } from '@distribusion/portal-lib/responsive';
import { Divider } from 'antd';
import { useTranslation } from 'lib/translation';

import './demo-indicator.less';

export const DemoIndicator = () => {
  const { t } = useTranslation();
  const { lg } = useBreakpoint();

  return (
    <>
      {lg && <Divider className="demo-indicator__line" />}
      <div className="demo-indicator__text">
        <Text size="sm" strong>
          {t('profile_menu_items.demo_mode')}
        </Text>
      </div>
    </>
  );
};
